import { useState } from "react";
import { mockCategories, mockProducts } from "@/mocks/dealerData";

export default function AdminCategoriesPage() {
  const [categories, setCategories] = useState(
    mockCategories.map((c) => ({
      ...c,
      productCount: mockProducts.filter((p) => p.categoryId === c.id).length,
    }))
  );
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState<typeof categories[0] | null>(null);
  const [name, setName] = useState("");
  const [deleteConfirm, setDeleteConfirm] = useState<string | null>(null);

  const openAdd = () => { setEditing(null); setName(""); setShowModal(true); };
  const openEdit = (c: typeof categories[0]) => { setEditing(c); setName(c.name); setShowModal(true); };

  const save = () => {
    if (!name.trim()) return;
    if (editing) {
      setCategories((prev) => prev.map((c) => (c.id === editing.id ? { ...c, name: name.trim() } : c)));
    } else {
      setCategories((prev) => [...prev, { id: "c" + Date.now(), name: name.trim(), productCount: 0 }]);
    }
    setShowModal(false);
  };

  const executeDelete = () => {
    if (!deleteConfirm) return;
    setCategories((prev) => prev.filter((c) => c.id !== deleteConfirm));
    setDeleteConfirm(null);
  };

  return (
    <div className="max-w-4xl mx-auto">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
        <div>
          <h4 className="text-lg font-semibold text-foreground-950"><a id="admin-categories-title">Kategori Yönetimi</a></h4>
          <p className="text-sm text-foreground-500 mt-0.5">{categories.length} kategori, toplam {categories.reduce((s, c) => s + c.productCount, 0)} ürün</p>
        </div>
        <button onClick={openAdd} className="flex items-center gap-2 px-4 py-2 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap">
          <i className="ri-add-line"></i> Kategori Ekle
        </button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {categories.map((c) => (
          <div key={c.id} className="bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-background-300/60 transition-colors group">
            <div className="flex items-start justify-between mb-3">
              <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center">
                <i className="ri-folder-line text-secondary-600 text-lg"></i>
              </div>
              <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                <button onClick={() => openEdit(c)} className="w-7 h-7 rounded-md flex items-center justify-center text-foreground-400 hover:text-primary-600 hover:bg-primary-100 cursor-pointer"><i className="ri-edit-line text-sm"></i></button>
                <button onClick={() => setDeleteConfirm(c.id)} className="w-7 h-7 rounded-md flex items-center justify-center text-foreground-400 hover:text-accent-500 hover:bg-accent-100 cursor-pointer"><i className="ri-delete-bin-line text-sm"></i></button>
              </div>
            </div>
            <h5 className="font-semibold text-foreground-950 mb-1">{c.name}</h5>
            <div className="flex items-center gap-2">
              <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-box-3-line"></i>
                {c.productCount} ürün
              </span>
            </div>
          </div>
        ))}
      </div>

      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30" onClick={() => setShowModal(false)}>
          <div className="bg-background-50 rounded-2xl p-6 w-full max-w-sm mx-4" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-4">
              <h4 className="text-base font-semibold text-foreground-950"><a id="admin-category-form">{editing ? "Kategori Düzenle" : "Yeni Kategori"}</a></h4>
              <button onClick={() => setShowModal(false)} className="w-8 h-8 rounded-md flex items-center justify-center text-foreground-400 hover:bg-background-100 cursor-pointer"><i className="ri-close-line"></i></button>
            </div>
            <div className="mb-4">
              <label className="block text-xs font-medium text-foreground-500 mb-1">Kategori Adı *</label>
              <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="w-full px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400" placeholder="Kategori adı girin" />
            </div>
            <div className="flex gap-2">
              <button onClick={() => setShowModal(false)} className="flex-1 py-2.5 bg-background-100 border border-background-200/70 text-foreground-600 rounded-lg text-sm font-medium hover:bg-background-200/70 transition-colors cursor-pointer whitespace-nowrap">İptal</button>
              <button onClick={save} className="flex-1 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap">Kaydet</button>
            </div>
          </div>
        </div>
      )}

      {deleteConfirm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30" onClick={() => setDeleteConfirm(null)}>
          <div className="bg-background-50 rounded-2xl p-6 w-full max-w-sm mx-4" onClick={(e) => e.stopPropagation()}>
            <div className="text-center mb-4">
              <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-3">
                <i className="ri-error-warning-line text-accent-600 text-xl"></i>
              </div>
              <h4 className="text-base font-semibold text-foreground-950"><a id="delete-cat-confirm">Kategoriyi Sil</a></h4>
              <p className="text-sm text-foreground-500 mt-1">Bu kategoriyi silmek istediğinize emin misiniz? Kategorideki ürünler kategorisiz kalacaktır.</p>
            </div>
            <div className="flex gap-2">
              <button onClick={() => setDeleteConfirm(null)} className="flex-1 py-2.5 bg-background-100 border border-background-200/70 text-foreground-600 rounded-lg text-sm font-medium hover:bg-background-200/70 transition-colors cursor-pointer whitespace-nowrap">İptal</button>
              <button onClick={executeDelete} className="flex-1 py-2.5 bg-accent-500 hover:bg-accent-600 text-background-50 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap">Sil</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}